import { Box, Flex, Heading, Separator, Switch, Text } from '@chakra-ui/react';
import { BaseAlert, BaseButton, BaseFields, BasePopover } from '@invara-dev/react-base';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { usePerformanceFlagStore } from '../../stores/performanceFlagStore';
import { useMemo } from 'react';

export const PerformanceSettings = () => {
  const performanceFlags = usePerformanceFlagStore();

  const allDisabled = useMemo(() => {
    return (
      performanceFlags.disableWorkflow &&
      performanceFlags.disableNewReplyNotifications &&
      performanceFlags.disableMyActivitiesSidebar &&
      performanceFlags.disableActivityOpenNotification &&
      performanceFlags.disableFooterTabs
    );
  }, [
    performanceFlags.disableWorkflow,
    performanceFlags.disableNewReplyNotifications,
    performanceFlags.disableMyActivitiesSidebar,
    performanceFlags.disableActivityOpenNotification,
    performanceFlags.disableFooterTabs
  ]);

  return (
    <BasePopover
      header={<Heading mb={'12px'}>Performance Settings</Heading>}
      trigger={
        <BaseButton size={'xs'} icon={faGear} toolTip={'Performance Settings'} aria-label={'Performance Settings'} />
      }
      onCancel={() => {}}>
      <BaseAlert>Changing a performance flag will force refresh your browser!</BaseAlert>
      <Box>
        <Flex direction='column' gap={'16px'}>
          <BaseButton
            size='sm'
            variant={allDisabled ? 'primary' : 'secondary'}
            onClick={() => {
              performanceFlags.toggleAll(!allDisabled);
              window.location.reload();
            }}>
            {allDisabled ? 'Enable All' : 'Disable All'}
          </BaseButton>

          <Separator />

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Workflow
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableWorkflow}
              onChangeControlled={(val) => {
                performanceFlags.setDisableWorkflow(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable New Reply Notifications
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableNewReplyNotifications}
              onChangeControlled={(val) => {
                performanceFlags.setDisableNewReplyNotifications(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable My Activities Sidebar
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableMyActivitiesSidebar}
              onChangeControlled={(val) => {
                performanceFlags.setDisableMyActivitiesSidebar(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Activity Open Notification
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableActivityOpenNotification}
              onChangeControlled={(val) => {
                performanceFlags.setDisableActivityOpenNotification(!!val);
                window.location.reload();
              }}
            />
          </Flex>

          <Flex justifyContent='space-between' alignItems='center'>
            <Text minW={'200px'} fontSize='sm'>
              Disable Footer Tabs
            </Text>
            <BaseFields.SwitchInput
              checked={performanceFlags.disableFooterTabs}
              onChangeControlled={(val) => {
                performanceFlags.setDisableFooterTabs(!!val);
                window.location.reload();
              }}
            />
          </Flex>
        </Flex>
      </Box>

      <Separator />

      <Flex direction='column' gap={'16px'}>
        <Heading size='sm'>Beta Features</Heading>
        <Text fontSize='sm' color='gray.600'>
          Experimental features that are opt-in. These may have issues and are subject to change.
        </Text>

        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            GDS Changes (Beta)
          </Text>
          <Switch.Root
            checked={performanceFlags.useGdsChanges}
            onCheckedChange={(event) => performanceFlags.setUseGdsChanges(event.checked)}>
            <Switch.HiddenInput aria-label='GDS Changes (Beta)' />
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Root>
        </Flex>
        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            GDS Cancel (Beta)
          </Text>
          <Switch.Root
            checked={performanceFlags.useGdsCancel}
            onCheckedChange={(event) => performanceFlags.setUseGdsCancel(event.checked)}>
            <Switch.HiddenInput aria-label='GDS Cancel (Beta)' />
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Root>
        </Flex>
        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            Postmark Invoice Generation (Beta)
          </Text>
          <BaseFields.SwitchInput
            checked={performanceFlags.usePostmarkInvoiceGeneration}
            onChangeControlled={(val) => {
              performanceFlags.setUsePostmarkInvoiceGeneration(!!val);
              window.location.reload();
            }}
          />
        </Flex>

        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            Reconciliations (Beta)
          </Text>
          <BaseFields.SwitchInput
            checked={performanceFlags.useReconciliationDashboard}
            onChangeControlled={(val) => {
              performanceFlags.setUseReconciliationDashboard(!!val);
              window.location.reload();
            }}
          />
        </Flex>

        <Flex justifyContent='space-between' alignItems='center'>
          <Text minW={'200px'} fontSize='sm'>
            Project Bookings (Beta)
          </Text>
          <BaseFields.SwitchInput
            checked={performanceFlags.useProjectContainerBookings}
            onChangeControlled={(val) => {
              performanceFlags.setUseProjectContainerBookings(!!val);
              window.location.reload();
            }}
          />
        </Flex>
      </Flex>

      {
        //need to fix later  <BetaMenu />
      }
    </BasePopover>
  );
};
